import axios from "axios";
import { domain } from "./constants";

const headers = {
  "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, x-requested-with",
  "Content-Type": "application/json",
  "Access-Control-Allow-origin": "*",
};
const getAuthHeaders = () => {
  const token = localStorage.getItem("access") || localStorage.getItem("access");
  let header = {
    headers: { Authorization: `Bearer ${token}` },
  };
  return header;
};

export const getActivityCategories = (cb) => {
  axios
    .get(
      `${domain}/activity/category/1`,
      {
        params: {
          visibility: true,
          ordering: "priority",
        },
      },
      headers
    )
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const publishActivities = async (activities, cb) => {
  const header = getAuthHeaders();
  const token = localStorage.getItem("access");

  axios
    .post(`${domain}/activity/post`, activities, header)
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const createDuonut = async (body,controller , cb) => {
  const header = getAuthHeaders();
  const token = localStorage.getItem("access");

  axios
    .post(`${domain}/duonut/`, body, header, { signal: controller.signal })
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const editActivities = async (id, activities, cb) => {
  const header = getAuthHeaders();

  axios
    .patch(`${domain}/duonut/${id}`, activities, header)
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const postMcq = (activities, cb) => {
  const header = getAuthHeaders();
  // console.log(activities);
  axios
    .post(`${domain}/activity/subtype/`, activities, header)
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const getActivityTypes = (id, cb) => {
  axios
    .get(
      `${domain}/activity/type`,
      {
        params: {
          // activity_category_id: 1,
          visibility: true,
          ordering: "priority",
        },
      },
      headers
    )
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const fetchActivityCategories = (cb) => {
  axios
    .get(`${domain}/activity/category?ordering=priority&visibility=true`, headers)
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const fetchActivityTypes = async (cb) => {
  axios
    .get(`${domain}/activity/type?visibility=true`, headers)
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

// old url =  ${domain}/activity/get
export const fetchSubtypes = (cb) => {
  axios
    .get(
      `${domain}/activity/subtype`,
      {
        params: {
          created_by_email: "admin@duonut.com",
          // activity_type_id: id,
          visibility: true,
          // created_by_email: "admin@duonut.com",
        },
      },
      headers
    )
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const fetchMastersData = (typeName, subtypeName, page, cb) => {
  let activityTypeName = typeName.toLowerCase().replace(/ /g, "_");
  // let subtypeNameUpdated = subtypeName.replace(/ /g, " ")
  if (activityTypeName === "fill_in_the_blanks") activityTypeName = "fill_in_blanks";
  if (activityTypeName === "true_and_false") activityTypeName = "true_or_false";
  if (activityTypeName === "hidden_words") activityTypeName = "crossword";

  axios
    .get(
      `${domain}/${activityTypeName}/`,
      {
        params: {
          created_by_email: "admin@duonut.com",
          activity_subtype: subtypeName,
          page: page,
          page_size: 10,
        },
      },
      headers
    )
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};

export const fetchDuonutCategories = async (cb) => {
  axios
    .get(`${domain}/duonut/category`, headers)
    .then((res) => cb(null, res))
    .catch((err) => cb(err, null));
};
